export default {

    DateFormat(now) {
        let year = "" + now.getFullYear();
        let month = "" + (now.getMonth() + 1);
        if (month.length == 1) {
            month = "0" + month;
        }
        let day = "" + now.getDate();
        if (day.length == 1) {
            day = "0" + day;
        }
        let hour = "" + now.getHours();
        if (hour.length == 1) {
            hour = "0" + hour;
        }
        let minute = "" + now.getMinutes();
        if (minute.length == 1) {
            minute = "0" + minute;
        }
        let second = "" + now.getSeconds();
        if (second.length == 1) {
            second = "0" + second;
        }

        return day + "/" + month + "/" + year + " " + hour + ":" + minute + ":" + second;
    },

    formatISODate(data) {
        // NOTA: la data deve essere passata in formato ISO (.toISOString())
        if (!data) return null;

        // Ricavo solo la data (primi 10 caratteri)
        data = data.substr(0, 10)

        const [year, month, day] = data.split("-");
        return `${day}/${month}/${year}`;
    },

    getErrorMsg(err) {
        // NOTA: quando non c'è la rete, err.response è undefined
        //       quando la pagina non è trovata (404) "data" è vuoto
        //       quando da Api non passo "message" prendo "data"
        return (err.response && err.response.data ? (err.response.data.message || err.response.data) : err.message)
    },

    numberWithCommas(x) {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return parts.join(",");
    },

    getWeekDay(dateString) {
        var days = ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'];
        let d = new Date(dateString);
        return days[d.getDay()];
    },

    isMobile() {
        return window.innerWidth <= 460;
    },

    delay(time) {
        return new Promise((resolve) => setTimeout(resolve, time));
    },

    normalizzaOra(val) {
        if (!val) return;

        // Replace dei separatori non validi con ":"
        val = val.replace(/[.,;-]/g, ":");

        // Se manca ":", aggiungo con :00
        if (!val.includes(":")) {
            val = val + ":00";
        }

        // Se solo ore tipo "9" -> "09:00"
        if (/^\d{1,2}$/.test(val)) {
            val = val.padStart(2, "0") + ":00";
        }

        let [ore, minuti = "00"] = val.split(":");

        // Ore sempre due cifre
        ore = ore.padStart(2, "0");

        // Caso speciale: se minuti è 1 cifra -> faccio ×10
        if (/^\d{1}$/.test(minuti)) {
            minuti = (parseInt(minuti) * 10).toString();
        }

        // Minuti sempre due cifre
        minuti = minuti.padStart(2, "0");

        return `${ore}:${minuti}`;
    },

    formatDate(input) {
        const d = new Date(input);
        if (isNaN(d.getTime())) {
            return null; // data non valida
        }
        // Estraggo yyyy-mm-dd
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }
}